import React from 'react';

const blockId = (block, index) =>
  `content-${index}-${block.substring(0, 20).replace(/[^a-zA-Z0-9]/g, '')}`;

const renderListItems = (block, key) => {
  const items = block.split('\n').filter((line) => line.startsWith('-'));
  return (
    <ul key={key} className="article-list">
      {items.map((line) => {
        const text = line.replace(/^-\s*/, '');
        return <li key={`${key}-${text.substring(0, 30)}`}>{text}</li>;
      })}
    </ul>
  );
};

const renderBlock = (block, index) => {
  const key = blockId(block, index);
  const trimmed = block.trim();

  if (!trimmed) return null;
  if (block.startsWith('### ')) {
    return (
      <h3 key={key} className="article-subheading">
        {block.replace('### ', '')}
      </h3>
    );
  }
  if (block.startsWith('## ')) {
    return (
      <h2 key={key} className="article-heading">
        {block.replace('## ', '')}
      </h2>
    );
  }
  if (block.startsWith('-')) {
    return renderListItems(block, key);
  }
  return (
    <p key={key} className="article-paragraph">
      {block}
    </p>
  );
};

const BlogPostContent = ({ content }) => (
  <div
    className="article-content prose prose-lg max-w-none"
    data-testid="blog-post-content"
  >
    {content.split('\n\n').map(renderBlock)}
  </div>
);

export default BlogPostContent;
